// @flow
import type { Player$Styles } from '../types/Styles';

const DEFAULT_STYLES: Player$Styles = {
   accentColor: '#81d4fa',
   mainColor: '#fff',
   submenuBgColor: '#eee',
   submenuColor: '#333',
   chaptersBubbleColor: '#1565C0',

   pltHeight: '135px',

   rplaylistHeight: '30%'
};

export default DEFAULT_STYLES;
